import Box from "./Box";
import HeadingSmall from "./HeadingSmall";
import React from "react";

function CalloutBlock({ value }) {
  return (
    <Box>
      <HeadingSmall>{value}</HeadingSmall>
    </Box>
  );
}
export default CalloutBlock;
